import * as React from "react";
import type { SVGProps } from "react";
const SvgChevronDoubleLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M13.2 7.2 18 12l-4.8 4.8M6 7.2l4.8 4.8L6 16.8"
    />
  </svg>
);
export default SvgChevronDoubleLeft;
